import React from 'react';
import { colors } from '../../../../colorVars';
import style from './Dropdown.module.css';

type Props = {
  children: React.ReactNode;
  value: string | number; 
  onChange: (value: any) => void;
  fontSize: string;
  backgroundColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  color:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  margin?: string;
  disabled?: boolean;
};

export const Dropdown = ({
  children,
  value,
  onChange,
  fontSize,
  color,
  backgroundColor,
  margin,
  disabled,
}: Props) => {
  return (
    <div className={style.container} style={{ fontSize, margin }}>
      <select
        disabled={disabled}
        style={{
          color: colors[color],
          backgroundColor: colors[backgroundColor],
          fontSize,
        }}
        className={style.select}
        value={value}
        onChange={({ target }) => onChange(target.value)}
      >
        {children}
      </select>
      <span
        className={style.arrows}
        style={{ backgroundColor: colors[backgroundColor] }}
      ></span>
    </div>
  );
};
